module.exports = {"TXTWCL_Accept_Price_Changes":{"id":"TXTWCL_Accept_Price_Changes","defaultMessage":"オッズの変更を認める","track":"Accept Price Changes"}}